import React from 'react';

const Header = ({ currentPage, setPage, completedPages }) => {
  const navItems = [
    { id: 'welcome', label: 'Start' },
    { id: 'context', label: 'Context' },
    { id: 'alignment', label: 'Alignment' },
    { id: 'insights', label: 'Insights' },
    { id: 'roadmap', label: 'Roadmap' },
    { id: 'summary', label: 'Summary' }
  ];

  return (
    <header className="bg-gradient-to-br from-[#2E5FA7] to-[#244C86] p-4 md:px-6 flex justify-between items-center flex-wrap gap-3 shadow-lg print:hidden">
      <div className="text-white">
        <div className="font-bold text-xl tracking-wide">VISUAL EDGE IT</div>
        <div className="text-[11px] opacity-85 mt-0.5">Total Technology Alignment Tool</div>
      </div>
      <nav className="flex gap-1 flex-wrap">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setPage(item.id)}
            className={`
              px-4 py-2.5 border-none rounded-lg cursor-pointer font-semibold text-xs flex items-center gap-2 transition-all
              ${currentPage === item.id 
                ? 'bg-white/25 text-white' 
                : completedPages.has(item.id)
                  ? 'bg-[#28A745]/30 text-white'
                  : 'bg-white/10 text-white hover:bg-white/20'}
            `}
          >
            <span className={`w-2 h-2 rounded-full ${currentPage === item.id ? 'bg-white' : completedPages.has(item.id) ? 'bg-[#28A745]' : 'bg-white/40'}`}></span>
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  );
};

export default Header;